import Parse from 'html-react-parser';

function BMP20148(props) {
    let svgCode =
        `<svg width="116" height="76" viewBox="0 0 116 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <style type="text/css">
        ${props.fontFace}
        </style>
            <rect width="116" height="76" fill="black"/>
            <rect y="38" width="116" height="38" fill="${props.backgroundFill}"/>
            <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="51" y="63.6523">COPY</tspan></text>
        </svg>`

    props.svgReturn(3, svgCode, "bmp00148", 116, 76);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20148;


